import React, { useState } from "react";
import { Tooltip, IconButton, withStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

// Shared dark, rich-content tooltip — pass the trigger via `icon` and the
// tooltip body via children (title/checklist/meta/links, whatever the
// caller needs), e.g.:
//
//   <InfoTooltip icon={<EditIcon style={{ color: "#9e9e9e" }} />}>
//     <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
//       Locked — batch documents received
//     </Typography>
//     <Typography variant="body2">Editing is disabled once ...</Typography>
//   </InfoTooltip>
const StyledTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: "#1c1c1e",
    color: "#fff",
    // Wider and larger than the MUI default: this tooltip carries several
    // sentences and an action, not a one-word label, and 13px was too small to
    // read comfortably.
    maxWidth: 500,
    padding: "20px 22px",
    borderRadius: 8,
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.35)",
    fontSize: 17,
    lineHeight: 1.65,
    // Room for the close button in the top-right corner.
    position: "relative",
  },
  arrow: {
    color: "#1c1c1e",
  },
}))(Tooltip);

// `closable` adds a close button; the tooltip otherwise opens on hover and closes when the cursor leaves.
const InfoTooltip = ({ icon, placement = "top", closable = false, children, ...tooltipProps }) => {
  const [open, setOpen] = useState(false);
  const title = closable ? (
    <>
      <IconButton
        size="small"
        aria-label="Close"
        onClick={() => setOpen(false)}
        style={{ position: "absolute", top: 6, right: 6, color: "#bdbdbd", padding: 4 }}
      >
        <CloseIcon style={{ fontSize: 18 }} />
      </IconButton>
      <div style={{ paddingRight: 24 }}>{children}</div>
    </>
  ) : (
    children
  );
  const control = closable
    ? { open, onOpen: () => setOpen(true), onClose: () => setOpen(false) }
    : {};
  return (
    <StyledTooltip
      title={title}
      arrow
      interactive
      placement={placement}
      {...control}
      {...tooltipProps}
    >
      <span style={{ display: "inline-flex", alignItems: "center" }}>{icon}</span>
    </StyledTooltip>
  );
};

export default InfoTooltip;
